
import {
  mapMutations,
  mapState,
} from 'vuex'

export default {
  beforeRouteLeave (to, from, next) {
    if (from.meta?.cache?.toPath?.indexOf(to.path) >= 0 || to?.name?.indexOf('TOtherPage') >= 0) {
      this.SET_ALIVE_COMPONENTS([from.name])
      const scrollTop = this.scrollDom()?.scrollTop
      this.scrollTop = scrollTop
    } else {
      this.DELETE_ALIVE_COMPONENTS(from.name)
    }

    next()
  },
  methods: {
    ...mapMutations('cache', [
      'SET_ALIVE_COMPONENTS',
      'DELETE_ALIVE_COMPONENTS',
    ]),
  },
  computed: { ...mapState('cache', ['scrollTop']) },
  activated () {
    const dom = this.scrollDom()
    const scrollTop = this.scrollTop

    if (scrollTop && dom) {
      dom.scrollTop = scrollTop
    }
  },
}
